module.exports = __webpack_public_path__ + "img/module.126df800.svg";